export default {
  getProductList: {
    uri: 'products',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getProductDetails: {
    uri: 'products/%product%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  // @TODO: create get product Images route for products without shop
  getProductImages: {
    uri: 'shops/%shop%/products/%product%/images',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/product.js